export const SECTIONS_PT = [
  {
    title: "1. Sobre o PASS Algarve",
    paras: [
      "O PASS Algarve é uma plataforma digital de experiências turísticas operada por GORGEOUS BLOSSOM TOURISM LDA, inscrita no NIF/NIPC 517 954 095, com sede em Lagos, no Algarve, Portugal, destinada a facilitar o acesso dos utilizadores a atrações, atividades, passeios, experiências gastronómicas e outras experiências turísticas disponibilizadas por parceiros independentes no Algarve.",
      "A plataforma permite ao utilizador adquirir diferentes modalidades de PASS, consultar as experiências incluídas e utilizar o seu PASS Digital através de QR Code.",
      "Salvo quando expressamente indicado em contrário, as atrações e experiências são prestadas pelos respetivos parceiros e fornecedores, que são responsáveis pela sua execução, segurança, horários, disponibilidade e cumprimento das obrigações legais aplicáveis.",
    ],
  },
  {
    title: "2. Aceitação dos Termos",
    paras: [
      "Ao utilizar a plataforma PASS Algarve, o utilizador concorda com estes Termos e Condições.",
      "Caso não concorde com alguma das condições aqui estabelecidas, não deverá concluir a compra ou utilizar os serviços disponibilizados pela plataforma.",
      "Determinadas atrações ou experiências poderão estar sujeitas a condições específicas estabelecidas pelo respetivo fornecedor.",
      "Sempre que existam condições específicas relevantes para uma experiência, estas poderão ser apresentadas na respetiva página antes da compra ou utilização.",
    ],
  },
  {
    title: "3. Conta de Cliente",
    paras: [
      "Para adquirir um PASS, poderá ser necessário criar uma conta de cliente.",
      "Durante o registo, o utilizador deverá fornecer informações verdadeiras, completas e atualizadas.",
      "O utilizador é responsável pela confidencialidade das suas credenciais de acesso e pelas atividades realizadas através da sua conta.",
      "O PASS Algarve poderá suspender ou bloquear contas quando existam indícios razoáveis de fraude, utilização abusiva, tentativa de utilização indevida de QR Codes ou violação destes Termos.",
    ],
  },
  {
    title: "4. O PASS Algarve",
    paras: [
      "O PASS Algarve poderá disponibilizar diferentes tipos de passaportes, cada um contendo atrações, experiências, benefícios ou condições próprias.",
      "Antes da conclusão da compra, o cliente terá acesso às informações disponibilizadas na plataforma relativamente ao PASS selecionado e às experiências nele incluídas, nomeadamente o preço, as experiências ou atrações incluídas e as respetivas condições e informações apresentadas na plataforma.",
      "Determinadas experiências poderão estar sujeitas a condições próprias do respetivo Parceiro/Fornecedor, incluindo, quando aplicável, reserva prévia, horários, disponibilidade, requisitos de participação, limitações de idade ou outras condições específicas. Essas informações poderão ser apresentadas na página da experiência, durante o processo de reserva ou comunicadas pelo respetivo Parceiro/Fornecedor.",
      "É responsabilidade do cliente consultar as informações e condições aplicáveis ao PASS e às experiências que pretende utilizar antes da respetiva utilização.",
    ],
    parasAfter: ["A composição e as condições de cada PASS são aquelas apresentadas ao cliente no momento da compra."],
  },
  {
    title: "5. Compra e Confirmação",
    paras: [
      "Após selecionar o PASS pretendido, o cliente deverá preencher os dados solicitados e concluir o respetivo pagamento.",
      "Após a confirmação do pagamento, o PASS adquirido ficará associado à conta do cliente.",
      "O cliente terá acesso ao seu PASS Algarve Digital e respetivo QR Code através da sua área de cliente ou através do meio indicado durante o processo de compra.",
      "O cliente deverá verificar os dados da compra imediatamente após a confirmação.",
    ],
  },
  {
    title: "6. PASS Digital e QR Code",
    paras: [
      "O QR Code disponibilizado ao cliente funciona como identificação digital para validação das experiências incluídas no PASS.",
      "Ao chegar à atração ou estabelecimento participante, o cliente deverá apresentar o seu QR Code. O parceiro procederá à respetiva validação através do sistema PASS Algarve.",
      "Após a validação de determinada experiência, esta será considerada utilizada e não poderá voltar a ser utilizada com o mesmo PASS, salvo indicação expressa em contrário.",
      "O QR Code é pessoal e não deverá ser duplicado, manipulado, comercializado ou utilizado de forma fraudulenta.",
      "O PASS Algarve reserva-se o direito de bloquear QR Codes em caso de suspeita fundamentada de fraude ou utilização indevida.",
    ],
  },
  {
    title: "7. Reservas e Disponibilidade",
    paras: [
      "Algumas experiências poderão exigir reserva prévia. Quando aplicável, essa informação será indicada na página da experiência ou comunicada ao cliente.",
      "A disponibilidade poderá variar em função de fatores como:",
    ],
    list: [
      "lotação;",
      "época do ano;",
      "condições meteorológicas;",
      "horários;",
      "manutenção;",
      "disponibilidade operacional do fornecedor.",
    ],
    parasAfter: [
      "A aquisição de um PASS não garante necessariamente disponibilidade imediata para todas as experiências em qualquer data ou horário pretendido pelo cliente quando a atividade estiver sujeita a reserva ou capacidade limitada.",
    ],
  },
  {
    title: "8. Parceiros e Fornecedores",
    paras: [
      "As atrações e experiências disponibilizadas através do PASS Algarve podem ser prestadas por empresas independentes.",
      "O respetivo fornecedor é responsável pela prestação da atividade ou experiência contratada e pelo cumprimento das obrigações legais relacionadas com a mesma. Isto inclui, quando aplicável: segurança, equipamentos, licenças, seguros, profissionais necessários, condições de participação e qualidade do serviço.",
      "O PASS Algarve disponibiliza a infraestrutura tecnológica e comercial que conecta os clientes aos parceiros participantes.",
      "Esta estrutura segue o princípio utilizado por grandes marketplaces turísticos, nos quais a atividade propriamente dita é prestada pelo fornecedor independente.",
    ],
  },
  {
    title: "9. Preços e Pagamentos",
    paras: [
      "Os preços apresentados na plataforma são indicados em euros (€), salvo indicação diferente.",
      "O pagamento deverá ser realizado através dos métodos disponibilizados durante o checkout.",
      "O processamento dos pagamentos poderá ser efetuado através da Stripe e da infraestrutura Stripe Connect.",
      "O PASS Algarve utiliza tecnologia de split de pagamentos, permitindo a distribuição automática dos valores da transação de acordo com as condições comerciais estabelecidas entre o PASS Algarve e os respetivos fornecedores.",
      "Os termos aplicáveis ao meio de pagamento utilizado pelo cliente poderão também estar sujeitos às condições do respetivo prestador de serviços de pagamento.",
    ],
  },
  {
    title: "10. Cancelamentos e Reembolsos",
    paras: [
      "As condições de cancelamento poderão variar conforme o tipo de PASS, atração ou experiência adquirida.",
      "Quando existirem condições específicas de cancelamento, estas serão apresentadas na respetiva oferta.",
      "Caso uma experiência seja cancelada pelo fornecedor por motivos operacionais, meteorológicos, técnicos, de segurança ou força maior, poderão ser disponibilizadas alternativas de reagendamento ou outras soluções aplicáveis ao caso concreto.",
      "Sempre que seja devido um reembolso, este será processado, sempre que tecnicamente possível, através do método de pagamento originalmente utilizado.",
    ],
  },
  {
    title: "11. Atrasos e Não Comparência",
    paras: [
      "É responsabilidade do cliente apresentar-se no local indicado dentro do horário estabelecido para a experiência.",
      "Atrasos poderão resultar na impossibilidade de participação.",
      "A não comparência do cliente (no-show) poderá implicar a perda da experiência, de acordo com as condições específicas do fornecedor.",
    ],
  },
  {
    title: "12. Alterações ou Cancelamentos pelo Fornecedor",
    paras: [
      "Por motivos de segurança, condições meteorológicas, força maior, manutenção, indisponibilidade operacional ou outras circunstâncias justificadas, uma experiência poderá ser alterada, reagendada ou cancelada.",
      "Sempre que possível, o cliente será informado através dos contactos associados à sua conta.",
      "O PASS Algarve procurará facilitar uma solução adequada entre o cliente e o fornecedor.",
    ],
  },
  {
    title: "13. Responsabilidade do Cliente",
    paras: ["O cliente compromete-se a:"],
    list: [
      "fornecer informações corretas;",
      "cumprir os horários;",
      "respeitar as instruções dos fornecedores;",
      "verificar eventuais requisitos de idade, saúde, vestuário ou participação;",
      "apresentar o QR Code válido;",
      "utilizar o PASS exclusivamente de acordo com as condições estabelecidas.",
    ],
    parasAfter: ["O cliente deverá avaliar se possui as condições necessárias para participar numa determinada atividade."],
  },
  {
    title: "14. Responsabilidade dos Fornecedores",
    paras: [
      "Cada fornecedor é responsável pela atividade ou experiência que presta.",
      "O fornecedor deverá manter todas as licenças, autorizações, seguros e condições de segurança exigidas pela legislação aplicável à sua atividade.",
      "As descrições, horários e informações relativas às experiências poderão ser fornecidas pelos respetivos parceiros, sendo estes responsáveis por comunicar alterações relevantes ao PASS Algarve.",
    ],
  },
  {
    title: "15. Responsabilidade do PASS Algarve",
    paras: [
      "O PASS Algarve é responsável pela operação da sua plataforma tecnológica e pelos serviços que presta diretamente.",
      "Quando atua apenas como intermediário entre cliente e fornecedor, não executa diretamente a atração ou experiência.",
      "Consequentemente, sem prejuízo dos direitos legalmente reconhecidos aos consumidores, a responsabilidade pela execução da experiência cabe ao fornecedor responsável pela mesma.",
    ],
  },
  {
    title: "16. Propriedade Intelectual",
    paras: [
      "Todos os elementos próprios da plataforma PASS Algarve, incluindo marca, identidade visual, textos, design, software, logótipos, elementos gráficos e conteúdos produzidos pelo PASS Algarve encontram-se protegidos pela legislação aplicável.",
      "É proibida a sua reprodução, utilização comercial ou distribuição sem autorização.",
      "Marcas, fotografias e conteúdos pertencentes aos parceiros permanecem propriedade dos respetivos titulares.",
    ],
  },
  {
    title: "17. Utilização Indevida e Fraude",
    paras: ["É expressamente proibido:"],
    list: [
      "copiar ou falsificar QR Codes;",
      "utilizar o mesmo benefício mais vezes do que permitido;",
      "manipular a plataforma;",
      "utilizar dados falsos;",
      "revender um PASS sem autorização;",
      "tentar obter acesso indevido a experiências;",
      "utilizar contas ou meios de pagamento de terceiros sem autorização.",
    ],
    parasAfter: [
      "Em situações de suspeita fundamentada de fraude, o PASS Algarve poderá suspender preventivamente a conta ou PASS enquanto procede à verificação da situação.",
    ],
  },
  {
    title: "18. Proteção de Dados",
    paras: [
      "O tratamento dos dados pessoais será realizado de acordo com a legislação aplicável, incluindo o Regulamento Geral sobre a Proteção de Dados (RGPD).",
      "Os dados poderão ser utilizados para finalidades necessárias à prestação do serviço, incluindo: processamento de compras, gestão da conta, validação do PASS, reservas, comunicação com clientes, prevenção de fraude e cumprimento de obrigações legais.",
      "Para informações detalhadas, o utilizador deverá consultar a Política de Privacidade do PASS Algarve.",
    ],
  },
  {
    title: "19. Comunicações",
    paras: [
      "O cliente aceita receber comunicações necessárias à execução das suas compras e experiências, incluindo confirmações, alterações, cancelamentos, informações operacionais e mensagens relacionadas com a sua conta.",
      "Estas comunicações poderão ser realizadas através dos dados fornecidos pelo cliente.",
      "Comunicações comerciais serão realizadas de acordo com as autorizações legalmente exigidas.",
    ],
  },
  {
    title: "20. Alterações aos Termos",
    paras: [
      "O PASS Algarve poderá atualizar estes Termos e Condições sempre que necessário devido a alterações legais, tecnológicas, operacionais ou comerciais.",
      "A versão atualizada será publicada na plataforma com indicação da data da última atualização.",
      "As compras já realizadas continuarão sujeitas às condições aplicáveis no momento da respetiva contratação, quando legalmente exigido.",
    ],
  },
  {
    title: "21. Lei Aplicável e Direitos do Consumidor",
    paras: [
      "Os presentes Termos e Condições são regidos pela legislação portuguesa, sem prejuízo das normas imperativas de proteção do consumidor que sejam aplicáveis.",
      "Nenhuma disposição destes Termos pretende excluir ou limitar direitos que sejam legalmente garantidos aos consumidores.",
    ],
  },
];

export const SECTIONS_EN = [
  {
    title: "1. About PASS Algarve",
    paras: [
      "PASS Algarve is a digital tourism experience platform operated by GORGEOUS BLOSSOM TOURISM LDA, registered under tax number (NIF/NIPC) 517 954 095, with registered office in Lagos, Algarve, Portugal, designed to facilitate users' access to attractions, activities, tours, gastronomic experiences and other tourism experiences provided by independent partners in the Algarve.",
      "The platform allows users to purchase different types of PASS, view the experiences included and use their Digital PASS via QR Code.",
      "Unless expressly stated otherwise, attractions and experiences are provided by the respective partners and suppliers, who are responsible for their delivery, safety, schedules, availability and compliance with applicable legal obligations.",
    ],
  },
  {
    title: "2. Acceptance of the Terms",
    paras: [
      "By using the PASS Algarve platform, the user agrees to these Terms and Conditions.",
      "If you do not agree with any of the conditions set out herein, you should not complete the purchase or use the services made available through the platform.",
      "Certain attractions or experiences may be subject to specific conditions established by the respective supplier.",
      "Whenever specific conditions relevant to an experience exist, they may be presented on the respective page before purchase or use.",
    ],
  },
  {
    title: "3. Customer Account",
    paras: [
      "To purchase a PASS, it may be necessary to create a customer account.",
      "During registration, the user must provide true, complete and up-to-date information.",
      "The user is responsible for the confidentiality of their access credentials and for the activities carried out through their account.",
      "PASS Algarve may suspend or block accounts where there are reasonable indications of fraud, abusive use, attempted misuse of QR Codes or violation of these Terms.",
    ],
  },
  {
    title: "4. The PASS Algarve",
    paras: [
      "PASS Algarve may offer different types of passports, each containing its own attractions, experiences, benefits or conditions.",
      "Before completing the purchase, the customer will have access to the information made available on the platform regarding the selected PASS and the experiences included in it, namely the price, the experiences or attractions included and the respective conditions and information presented on the platform.",
      "Certain experiences may be subject to specific conditions of the respective Partner/Supplier, including, where applicable, prior booking, schedules, availability, participation requirements, age restrictions or other specific conditions. This information may be presented on the experience page, during the booking process or communicated by the respective Partner/Supplier.",
      "It is the customer's responsibility to review the information and conditions applicable to the PASS and the experiences they intend to use before using them.",
    ],
    parasAfter: ["The composition and conditions of each PASS are those presented to the customer at the time of purchase."],
  },
  {
    title: "5. Purchase and Confirmation",
    paras: [
      "After selecting the desired PASS, the customer must fill in the requested details and complete the respective payment.",
      "Upon payment confirmation, the purchased PASS will be linked to the customer's account.",
      "The customer will have access to their PASS Algarve Digital and respective QR Code through their customer area or through the means indicated during the purchase process.",
      "The customer should verify the purchase details immediately after confirmation.",
    ],
  },
  {
    title: "6. Digital PASS and QR Code",
    paras: [
      "The QR Code provided to the customer works as a digital identification for validating the experiences included in the PASS.",
      "Upon arrival at the participating attraction or establishment, the customer must present their QR Code. The partner will validate it through the PASS Algarve system.",
      "Once a given experience has been validated, it will be considered used and cannot be used again with the same PASS, unless expressly stated otherwise.",
      "The QR Code is personal and must not be duplicated, tampered with, sold or used fraudulently.",
      "PASS Algarve reserves the right to block QR Codes in case of well-founded suspicion of fraud or misuse.",
    ],
  },
  {
    title: "7. Bookings and Availability",
    paras: [
      "Some experiences may require prior booking. Where applicable, this information will be indicated on the experience page or communicated to the customer.",
      "Availability may vary depending on factors such as:",
    ],
    list: [
      "capacity;",
      "time of year;",
      "weather conditions;",
      "schedules;",
      "maintenance;",
      "the supplier's operational availability.",
    ],
    parasAfter: [
      "The purchase of a PASS does not necessarily guarantee immediate availability for all experiences on any date or time desired by the customer where the activity is subject to booking or limited capacity.",
    ],
  },
  {
    title: "8. Partners and Suppliers",
    paras: [
      "The attractions and experiences made available through PASS Algarve may be provided by independent companies.",
      "The respective supplier is responsible for delivering the contracted activity or experience and for complying with the legal obligations related to it. This includes, where applicable: safety, equipment, licences, insurance, required professionals, participation conditions and service quality.",
      "PASS Algarve provides the technological and commercial infrastructure that connects customers to participating partners.",
      "This structure follows the principle used by large tourism marketplaces, in which the activity itself is provided by the independent supplier.",
    ],
  },
  {
    title: "9. Prices and Payments",
    paras: [
      "Prices displayed on the platform are indicated in euros (€), unless stated otherwise.",
      "Payment must be made through the methods made available during checkout.",
      "Payment processing may be carried out through Stripe and the Stripe Connect infrastructure.",
      "PASS Algarve uses split-payment technology, allowing the automatic distribution of transaction amounts in accordance with the commercial conditions established between PASS Algarve and the respective suppliers.",
      "The terms applicable to the payment method used by the customer may also be subject to the conditions of the respective payment service provider.",
    ],
  },
  {
    title: "10. Cancellations and Refunds",
    paras: [
      "Cancellation conditions may vary depending on the type of PASS, attraction or experience purchased.",
      "Where specific cancellation conditions exist, they will be presented in the respective offer.",
      "If an experience is cancelled by the supplier for operational, weather-related, technical, safety or force majeure reasons, rescheduling alternatives or other solutions applicable to the specific case may be made available.",
      "Whenever a refund is due, it will be processed, whenever technically possible, through the payment method originally used.",
    ],
  },
  {
    title: "11. Delays and No-Show",
    paras: [
      "It is the customer's responsibility to arrive at the indicated location within the time set for the experience.",
      "Delays may result in the inability to participate.",
      "Failure to show up (no-show) may result in the loss of the experience, in accordance with the supplier's specific conditions.",
    ],
  },
  {
    title: "12. Changes or Cancellations by the Supplier",
    paras: [
      "For reasons of safety, weather conditions, force majeure, maintenance, operational unavailability or other justified circumstances, an experience may be changed, rescheduled or cancelled.",
      "Whenever possible, the customer will be informed through the contact details associated with their account.",
      "PASS Algarve will seek to facilitate an appropriate solution between the customer and the supplier.",
    ],
  },
  {
    title: "13. Customer Responsibility",
    paras: ["The customer undertakes to:"],
    list: [
      "provide correct information;",
      "comply with schedules;",
      "respect the suppliers' instructions;",
      "check any age, health, clothing or participation requirements;",
      "present a valid QR Code;",
      "use the PASS exclusively in accordance with the established conditions.",
    ],
    parasAfter: ["The customer should assess whether they meet the necessary conditions to participate in a given activity."],
  },
  {
    title: "14. Suppliers' Responsibility",
    paras: [
      "Each supplier is responsible for the activity or experience it provides.",
      "The supplier must maintain all licences, authorisations, insurance and safety conditions required by the legislation applicable to its activity.",
      "Descriptions, schedules and information relating to the experiences may be provided by the respective partners, who are responsible for communicating relevant changes to PASS Algarve.",
    ],
  },
  {
    title: "15. PASS Algarve's Responsibility",
    paras: [
      "PASS Algarve is responsible for the operation of its technological platform and for the services it provides directly.",
      "When acting solely as an intermediary between customer and supplier, it does not directly deliver the attraction or experience.",
      "Consequently, without prejudice to the rights legally granted to consumers, responsibility for the delivery of the experience lies with the supplier responsible for it.",
    ],
  },
  {
    title: "16. Intellectual Property",
    paras: [
      "All proprietary elements of the PASS Algarve platform, including brand, visual identity, texts, design, software, logos, graphic elements and content produced by PASS Algarve, are protected by applicable legislation.",
      "Their reproduction, commercial use or distribution without authorisation is prohibited.",
      "Trademarks, photographs and content belonging to partners remain the property of their respective owners.",
    ],
  },
  {
    title: "17. Misuse and Fraud",
    paras: ["The following is expressly prohibited:"],
    list: [
      "copying or forging QR Codes;",
      "using the same benefit more times than permitted;",
      "tampering with the platform;",
      "using false information;",
      "reselling a PASS without authorisation;",
      "attempting to gain undue access to experiences;",
      "using third-party accounts or payment methods without authorisation.",
    ],
    parasAfter: [
      "In situations of well-founded suspicion of fraud, PASS Algarve may preventively suspend the account or PASS while verifying the situation.",
    ],
  },
  {
    title: "18. Data Protection",
    paras: [
      "Personal data will be processed in accordance with applicable legislation, including the General Data Protection Regulation (GDPR).",
      "Data may be used for purposes necessary for the provision of the service, including: purchase processing, account management, PASS validation, bookings, customer communication, fraud prevention and compliance with legal obligations.",
      "For detailed information, users should consult the PASS Algarve Privacy Policy.",
    ],
  },
  {
    title: "19. Communications",
    paras: [
      "The customer agrees to receive communications necessary for the execution of their purchases and experiences, including confirmations, changes, cancellations, operational information and messages related to their account.",
      "These communications may be made using the details provided by the customer.",
      "Commercial communications will be made in accordance with legally required authorisations.",
    ],
  },
  {
    title: "20. Changes to the Terms",
    paras: [
      "PASS Algarve may update these Terms and Conditions whenever necessary due to legal, technological, operational or commercial changes.",
      "The updated version will be published on the platform with an indication of the date of the last update.",
      "Purchases already made will remain subject to the conditions applicable at the time of the respective contract, where legally required.",
    ],
  },
  {
    title: "21. Applicable Law and Consumer Rights",
    paras: [
      "These Terms and Conditions are governed by Portuguese law, without prejudice to any mandatory consumer protection rules that may apply.",
      "Nothing in these Terms is intended to exclude or limit rights legally guaranteed to consumers.",
    ],
  },
];
